import { toast } from "react-toastify";

// Estilo personalizado
const toastOptions = {
  autoClose: 3000, // Cierre más rápido
  hideProgressBar: true, // Sin barra de progreso
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  theme: "light", // Tema más claro
  style: {
    borderRadius: "10px", // Bordes redondeados
    boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.1)", // Sombra suave
    fontSize: "14px", // Tamaño de texto más pequeño
    padding: "12px", // Espaciado cómodo
  },
};

// Warning Toast
export const warningToast = (mensaje, position = "top-center") => {
  toast.warn(mensaje, { position, ...toastOptions });
};

// Success Toast
export const successToast = (mensaje, position = "top-center") => {
  toast.success(mensaje, { position, ...toastOptions });
};

// Danger Toast
export const dangerToast = (mensaje, position = "top-center") => {
  toast.error(mensaje, { position, ...toastOptions });
};

// Info Toast
export const infoToast = (mensaje, position = "top-center") => {
  toast.info(mensaje, { position, ...toastOptions });
};
